/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import $ from 'jquery';
import 'select2';

export default function initSelect2(element, initialConfig) {
  const cfg = {
    ...initialConfig,
  };

  if (element.dataset.entriesUrl) {
    cfg.ajax = {
      url: element.dataset.entriesUrl,
      delay: 100,
      data(params) {
        return {
          query: params.term,
          page: params.page || 1,
        };
      },
      processResults(data) {
        return {
          results: data.options.map(option => ({
            id: option.value,
            text: option.label,
          })),
          pagination: {
            more: data.more,
          },
        };
      },
    };
  }

  $(element).select2(cfg);
}
